import { useEffect } from 'react';
import { SectionLabel } from '@perch/ui';

interface LegalPageLayoutProps {
  title: string;
  label: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export function LegalPageLayout({ title, label, lastUpdated, children }: LegalPageLayoutProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${title} — Perch`;
  }, [title]);

  return (
    <main className="max-w-4xl mx-auto px-6 py-16">
      <SectionLabel className="mb-3">{label}</SectionLabel>
      <h1 className="text-3xl sm:text-4xl font-serif text-stone-900 dark:text-stone-100 mb-2">
        {title}
      </h1>
      <p className="text-sm text-stone-400 dark:text-stone-500 mb-12">
        Last updated: {lastUpdated}
      </p>

      <div className="prose-legal space-y-8 text-stone-600 dark:text-stone-400 text-[15px] leading-relaxed">
        {children}
      </div>
    </main>
  );
}
